import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import React from 'react';
import { FadedPaper } from '../../theme/StyledFields';

interface Props {
    recommendations: string[];
}

const RecommendationsSection: React.FC<Props> = ({ recommendations }) => (
    <FadedPaper sx={{ p: 3, mb: 3 }} data-testid="section-recommendations">
        <Typography variant="h5" sx={{ mb: 2 }}>Recommendations</Typography>
        <List dense>
            {recommendations.map((rec, idx) => (
                <ListItem key={idx} alignItems="flex-start">
                    <ListItemIcon sx={{ minWidth: 36, mt: 0.5 }}>
                        <CheckCircleOutlineIcon color="primary" fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={rec} />
                </ListItem>
            ))}
        </List>
    </FadedPaper>
);

export default RecommendationsSection;
